/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ISmweProductCollection contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum layout {
    carousel = 'carousel',
    grid = 'grid'
}

export interface ISmweProductCollectionConfig extends Msdyn365.IModuleConfig {
    addToCart?: boolean;
    productCollection: Msdyn365.IProductList;
    heading?: IHeadingData;
    layout?: layout;
    imageSettings?: Msdyn365.IImageSettings;
    className?: string;
    showPrice?: boolean;
    showStarRating?: boolean;
    launchLightboxButtonText?: string;
    productLightboxHref: string;
    productLightboxWidth: number;
    productLightboxHeight: number;
    productLightboxClassName?: string;
    productLightboxIframeClassName?: string;
    cardBanner?: string;
    showQuantityAsDropdown?: boolean;
}

export interface ISmweProductCollectionResources {
    priceFree: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    originalPriceText: string;
    currentPriceText: string;
    addToCartText: string;
    addToCartMessage: string;
    giftCardText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ISmweProductCollectionProps<T> extends Msdyn365.IModule<T> {
    resources: ISmweProductCollectionResources;
    config: ISmweProductCollectionConfig;
}
